import { MULTICALL_CONTRACT_ADDRESS } from '../../constants';
import { Decimal } from '../../datastructures';
import { NostraToken } from '../../interfaces';
import { MultiCallContract } from '../../services';
import nostraTokenListAtom from './nostraTokenListAtom';
import { createAsyncAtom } from '../../lib/state';
import { RpcProvider } from 'starknet';
import rpcProviderAtom from '../rpcProviderAtom';

export type NostraTokenTotalSupplyCapMap = { [nostraTokenAddress: string]: Decimal };

const RESPONSE_CHUNK_SIZE = 3;

const fetchData = async (nostraTokens: NostraToken[], provider: RpcProvider) => {
  try {
    const calldata = nostraTokens.map(nostraToken => {
      return {
        contractAddress: nostraToken.address,
        entrypoint: 'total_supply_cap',
      };
    });

    const multiCallContract = new MultiCallContract(MULTICALL_CONTRACT_ADDRESS, provider);

    const result = await multiCallContract.aggregate(calldata);

    if (!result) {
      return null;
    }

    const nostraTokenTotalSupplyCapMap: NostraTokenTotalSupplyCapMap = {};

    for (let i = 0; i < result.length; i += RESPONSE_CHUNK_SIZE) {
      const nostraToken = nostraTokens[i / RESPONSE_CHUNK_SIZE];

      // Index 1,2 is for totalSupplyCap
      const totalSupplyCap = new Decimal(
        { low: result[i + 1] || 0n, high: result[i + 2] || 0n },
        nostraToken.tokenPrecision,
      );

      nostraTokenTotalSupplyCapMap[nostraToken.address] = totalSupplyCap;
    }

    return nostraTokenTotalSupplyCapMap;
  } catch (error) {
    console.error(`useNostraTokenTotalSupplyCap - Failed to load nostra token total supply cap!`, error);
    return null;
  }
};

const nostraTokenTotalSupplyCapAtom = createAsyncAtom(async get => {
  const nostraTokenList = await get(nostraTokenListAtom);
  const provider = await get(rpcProviderAtom);

  return fetchData(nostraTokenList, provider);
});

export default nostraTokenTotalSupplyCapAtom;
